import React from 'react'
import PropTypes from 'prop-types'
import CourseNavItem from './CourseNavItem'

const CourseNavModule = props => {
  let [moduleOpen, setModuleOpen] = React.useState(false)
  const handleClick = event => {
    event.preventDefault()
    setModuleOpen(!moduleOpen)
  }
  const handleKeyDown = event => {
    event.preventDefault()
    if (event.key === 'Enter') {
      setModuleOpen(!moduleOpen)
    }
  }
  return (
    <React.Fragment>
      <CourseNavItem
        itemTitle={props.itemTitle}
        href={`/reader/web/${props.coursenum}/${props.lessonsAndLinks[0].id}/`}
        paddingLeft="50px"
        onClick={handleClick}
        chevronOpen={moduleOpen}
        handleKeyDown={handleKeyDown}
        isLocked={props.isLocked}
      />
      {moduleOpen
        ? props.lessonsAndLinks.map(lesson => (
            <div key={lesson.id}>
              <CourseNavItem
                itemTitle={lesson.title}
                paddingLeft="90px"
                href={`/reader/web/${props.coursenum}/${lesson.id}/`}
                isLocked={lesson.isLocked}
              />
            </div>
          ))
        : null}
    </React.Fragment>
  )
}

CourseNavModule.propTypes = {
  moduleTitle: PropTypes.string,
  moduleActive: PropTypes.bool,
  lessonsAndLinks: PropTypes.array,
  itemTitle: PropTypes.string,
  onClick: PropTypes.func,
  coursenum: PropTypes.string,
  isLocked: PropTypes.bool,
}

export default CourseNavModule
